
import {
  Vue, Component, Prop, Watch, Ref,
} from 'vue-property-decorator'
import FormInput from '@/components/FormInput/FormInput.vue'
import Widget from '@/components/Widget/Widget.vue'
import { clone as _clone } from 'lodash'
// @ts-ignore
import LiquorTree from 'liquor-tree'
import 'vue-slider-component/theme/antd.css'
import CheckboxInput from '@/components/CheckboxInput/index.vue'
import DataForm from '@/components/DataForm/DataForm.vue'
import WebMessage from '@/models/WebMessage'
import MediaProperty from '@/models/MediaProperty'
import formData from './form'

Vue.use(LiquorTree)

@Component({
  components: {
    DataForm,
    FormInput,
    CheckboxInput,
    Widget,
  },
})
export default class MediaPropertyForm extends Vue {
  @Ref() readonly treeview: any

  @Prop({ default: '' })
  private id!: string

  @Prop({
    default: 'full',
  })
  private view_mode!: string

  public adunit_filter: string = ''

  public adunits = []

  public adunits_distribution: number[] = []

  public busy = false

  public loading = true

  public model: MediaProperty = new MediaProperty()

  public show_line_items_using_this: boolean = false

  public depending_line_items: any = []

  public confirm_update: any = false

  public response_msg: any = ''

  public can_save: boolean = true

  public get form() {
    return formData
  }

  public cancel() {
    if (this.view_mode == 'sidebar') {
      this.$emit('update:show_sidebar', false)
    } else {
      this.$router.push({ name: 'MediaProperties' })
    }
  }

  public onSubmit(model: MediaProperty) {
    this.busy = true

    this.model.save().then(response => {
      this.busy = false
      if (response.status == 200) {
        this.$router.push({ name: 'MediaProperties' })
      }
    })
  }

  public init() {
    this.loading = true
    const { query } = this.$route
    if (this.id) {
      MediaProperty.find(this.id).then(media_property => {
        if (media_property instanceof MediaProperty) {
          this.model = media_property
          this.loading = false
        }
      })
    } else if (query.from && typeof query.from === 'string') {
      MediaProperty.find(query.from).then(media_property => {
        if (media_property instanceof MediaProperty) {
          this.model = media_property.clone()
          this.model.id = ''
          this.loading = false
        }
      })
    } else {
      this.loading = false
    }
  }

  public created() {
    this.init()
  }
}
